// removed by extract-text-webpack-plugin
module.exports = {"switchProvider":"SwitchProvider__switchProvider","switchProviderContent":"SwitchProvider__switchProviderContent","title":"SwitchProvider__title","message":"SwitchProvider__message","providers":"SwitchProvider__providers","provider":"SwitchProvider__provider","logo":"SwitchProvider__logo","button":"SwitchProvider__button","newProvider":"SwitchProvider__newProvider","seperator":"SwitchProvider__seperator","change":"SwitchProvider__change","growDotQello":"SwitchProvider__growDotQello","growDotBlue":"SwitchProvider__growDotBlue","growDotGolden":"SwitchProvider__growDotGolden"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/SwitchProvider/SwitchProvider.scss
// module id = 1919
// module chunks = 0